export default __webpack_public_path__ + "static/media/the_sandbox.c0ed51ce.svg";